import { createSlice } from "@reduxjs/toolkit";
import {
  getReceiptAccountUpdationByApproval,
  updateReceiptAccountUpdationByApproval,
  getReceiptAccountUpdationByApprovalReport,
} from "./actions/receiptAccountUpdationAction";

const initialState = {
  loading: false,
  procAccontUpdatedUsers: null,
  procurementAccountAuditActivity: null,

  procurementAccountAuditApproval: null,
  totalByUpdateApproval: 0,
  procAccountAuditApprovalFilters: {},
  procAccountAuditApprovalPageState: { page: 1, pageSize: 50 },

  procurementAccountAuditApprovalReport: null,
  totalByUpdateApprovalReport: 0,
  procAccountAuditApprovalReportFilters: {},
  procAccountAuditApprovalReportPageState: { page: 1, pageSize: 50 },
};

export const receiptAccountUpdationSlice = createSlice({
  name: "procurementAccountAudit",
  initialState,
  reducers: {
    setProcurementAccountAuditActivity: (state, action) => {
      state.procurementAccountAuditActivity = action.payload;
    },
    setProcurementAccountAuditActivityNull: (state) => {
      state.procurementAccountAuditActivity = null;
    },

    setProcAccountAuditApprovalFilters: (state, action) => {
      const { payload } = action;
      state.procAccountAuditApprovalFilters = payload || {};
    },
    resetProcAccountAuditApprovalFilters: (state) => {
      state.procAccountAuditApprovalFilters = {};
    },

    setProcAccountAuditApprovalPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procAccountAuditApprovalPageState = {
          ...state.procAccountAuditApprovalPageState,
          page,
        };
      }
      if (pageSize) {
        state.procAccountAuditApprovalPageState = {
          ...state.procAccountAuditApprovalPageState,
          pageSize,
        };
      }
    },

    setProcAccountAuditApprovalReportFilters: (state, action) => {
      const { payload } = action;
      state.procAccountAuditApprovalReportFilters = payload || {};
    },
    resetProcAccountAuditApprovalReportFilters: (state) => {
      state.procAccountAuditApprovalReportFilters = {};
    },

    setProcAccountAuditApprovalReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.procAccountAuditApprovalReportPageState = {
          ...state.procAccountAuditApprovalReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.procAccountAuditApprovalReportPageState = {
          ...state.procAccountAuditApprovalReportPageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getReceiptAccountUpdationByApproval.pending, (state) => {
      state.loading = true;
    })
    .addCase(getReceiptAccountUpdationByApproval.fulfilled, (state, action) => {
      const { data, count, user } = action.payload;
      state.loading = false;
      state.procurementAccountAuditApproval = data;
      state.procAccontUpdatedUsers = user;
      state.totalByUpdateApproval = count;
    })
    .addCase(getReceiptAccountUpdationByApproval.rejected, (state) => {
      state.loading = false;
    });
    builder
      .addCase(updateReceiptAccountUpdationByApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateReceiptAccountUpdationByApproval.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementAccountAuditApproval = data;
        state.procAccontUpdatedUsers = user;
        state.totalByUpdateApproval = count;
      })
      .addCase(updateReceiptAccountUpdationByApproval.rejected, (state) => {
        state.loading = false;
      });
      builder
      .addCase(getReceiptAccountUpdationByApprovalReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReceiptAccountUpdationByApprovalReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.procurementAccountAuditApprovalReport = data;
        state.procAccontUpdatedUsers = user;
        state.totalByUpdateApprovalReport = count;
      })
      .addCase(getReceiptAccountUpdationByApprovalReport.rejected, (state) => {
        state.loading = false;
      });
  },

});

export const {
  setProcurementAccountAuditActivity,
  setProcurementAccountAuditActivityNull,

  setProcAccountAuditApprovalFilters,
  resetProcAccountAuditApprovalFilters,

  setProcAccountAuditApprovalPage,

  setProcAccountAuditApprovalReportFilters,
  resetProcAccountAuditApprovalReportFilters,

  setProcAccountAuditApprovalReportPage,

} = receiptAccountUpdationSlice.actions;

export default receiptAccountUpdationSlice.reducer;
